// Guards puras sobre la FORMA del `detail` de una entrada de la bitácora.
// El detail es un JSONField libre del backend: puede venir con cualquier cosa (shapes
// históricos, campos faltantes, tipos cambiados). Todas las guards toleran null/no-objeto
// devolviendo false — nunca lanzan.

export function isPlainObject(value) {
    return !!value && typeof value === 'object' && !Array.isArray(value);
}

function isPrimitive(value) {
    return value === null || typeof value !== 'object';
}

// {amount, currency} — shape de montos de BUDGET_MODIFIED y afines.
export function isAmount(value) {
    return isPlainObject(value) && ('amount' in value || 'currency' in value);
}

// {before, after} con valores primitivos o montos — una celda de diff.
export function isFieldDiff(value) {
    if (!isPlainObject(value)) return false;
    if (!('before' in value) && !('after' in value)) return false;
    return [value.before, value.after].every(v => v === undefined || isPrimitive(v) || isAmount(v));
}

// {campo: {before, after}, ...} SIN envoltorio — shape de BU_EDITED, CLIENT_PROFILE_UPDATED
// y CLIENT_INTEGRATIONS_UPDATED. Exige que TODAS las entradas sean diffs (y no "alguna")
// para no capturar payloads mixtos por accidente.
export function isFlatDiffShape(detail) {
    if (!isPlainObject(detail)) return false;
    const entries = Object.values(detail);
    return entries.length > 0 && entries.every(isFieldDiff);
}

// {..., changes: {campo: {before, after}}} — shape de AD_ACCOUNT_EDITED / USER_EDITED.
export function isNestedDiffShape(detail) {
    if (!isPlainObject(detail)) return false;
    if (!isPlainObject(detail.changes)) return false;
    return Object.values(detail.changes).some(isFieldDiff);
}

// before/after sueltos en la raíz, con valores primitivos o montos — BUDGET_MODIFIED,
// CAMPAIGN_/ADGROUP_BUDGET_MODIFIED y los platform changes de un solo campo.
export function isBeforeAfterShape(detail) {
    if (!isPlainObject(detail)) return false;
    if (!('before' in detail) && !('after' in detail)) return false;
    return [detail.before, detail.after].every(v => v === undefined || isPrimitive(v) || isAmount(v));
}

export function isAlertShape(detail) {
    return isPlainObject(detail) && ('kind' in detail || 'indicator' in detail);
}

// [{name, ...}, ...] — la lista de campañas de DAILY_LIMIT_EXCEEDED.
export function isCampaignList(value) {
    return Array.isArray(value)
        && value.length > 0
        && value.every(v => isPlainObject(v) && 'name' in v);
}
